export default __webpack_public_path__ + "static/media/3e5bf537a38bda8a865f35089b106637.md";